<template>
  <div>
    <!-- <SInput
      label="attribute"
      v-model="attributeName" 
    /> -->
    <div class="toolbar">
      <a href="javascript:void(0)" @click="openTableDialog()">
        <span class="fa fa-table"> </span>
      </a>
      |
      <a href="javascript:void(0)" @click="format('bold')">
        <span class="fa fa-bold"> </span>
      </a>
      <a href="javascript:void(0)" @click="format('underline')">
        <span class="fa fa-underline"> </span>
      </a>
      <a href="javascript:void(0)" @click="format('italic')">
        <span class="fa fa-italic"> </span>
      </a>
      <a href="javascript:void(0)" @click="format('strikethrough')">
        <span class="fa fa-strikethrough"> </span>
      </a>
      |
      <a href="javascript:void(0)" @click="format('subscript')">
        <span class="fa fa-subscript"> </span>
      </a>

      <a href="javascript:void(0)" @click="format('superscript')">
        <span class="fa fa-superscript"> </span>
      </a>
      |
      <a href="javascript:void(0)" @click="format('insertHorizontalRule')">
        <span class="fas fa-grip-lines-vertical fa-rotate-90"> </span>
      </a>

      <a href="javascript:void(0)" @click="format('insertLineBreak')">
        <span class="fa fa-reply fa-rotate-360 fa-flip-vertical"> </span>
      </a>
      |
      <a href="javascript:void(0)" @click="format('justifyLeft')">
        <span class="fa fa-align-left"> </span>
      </a>
      <a href="javascript:void(0)" @click="format('justifyRight')">
        <span class="fa fa-align-right"> </span>
      </a>
      <a href="javascript:void(0)" @click="format('justifyCenter')">
        <span class="fa fa-align-center"> </span>
      </a>
      <a href="javascript:void(0)" @click="format('justifyFull')">
        <span class="fa fa-align-justify"> </span>
      </a>
      |
      <a href="javascript:void(0)" @click="format('copy')">
        <span class="fa fa-copy"> </span>
      </a>
      <a href="javascript:void(0)" @click="format('cut')">
        <span class="fa fa-cut"> </span>
      </a>
      <a href="javascript:void(0)" @click="format('paste')">
        <span class="fas fa-paste"> </span>
      </a>
      <a href="javascript:void(0)" @click="format('delete')">
        <span class="far fa-trash-alt"> </span>
      </a>
      <a href="javascript:void(0)" @click="format('undo')">
        <span class="fa fa-undo"> </span>
      </a>
      <a href="javascript:void(0)" @click="format('redo')">
        <span class="fa fa-redo"> </span>
      </a>
      <a href="javascript:void(0)" @click="format('selectAll')">
        <span>Select All </span>
      </a>
      |
      <a href="javascript:void(0)" @click="openAttributeDialog()">
        <span class="fa fa-signature"> </span>
      </a>
      <a href="javascript:void(0)" @click="sourceCode()">
        <span class="fa fa-code"> </span>
      </a>
      <a href="javascript:void(0)" @click="addDiv()">
        <span class="fa"> div</span>
      </a>

      <!-- 
        <a href="javascript:void(0)" @click="format('outdent')">
          <span class="fa fa-list">  </span>
        </a>
        <a href="javascript:void(0)" @click="format('styleWithCss')">
          <span class="fa fa-list">  </span>
        </a>
        <a href="javascript:void(0)" @click="addGrid()">
          <span class="fa fa-grid">  </span>
        </a>
        <a href="javascript:void(0)" @click="format('defaultParagraphSeparator')">
          <span class="fa fa-list">  </span>
        </a>
        <a href="javascript:void(0)" @click="format('formatBlock')">
          <span class="fa fa-list">  </span>
        </a> 
      -->
    </div>

    <div class="editor" id="sharkEditor"></div>
    <Table v-if="tableDialog" @close="closeTableDialog" @addRows="addTable" />
    <AddAttribute
      v-if="attributeDialogFlag"
      :selectedElementId="selectedElementId"
      @close="closeAttributeDialog"
      @add="addAttribute"
    />
  </div>
</template>

<script>
import jQuery from "jquery";
import Vue from "vue";
const $ = jQuery;
("useCSS");
window.$ = $;
import Table from "./Table";
import AddAttribute from "./AddAttribute";
import SButton from "../SButton";
import SInput from "../SInput";
import * as JSFunctions from "../../Functions/Functions.js";

const variableMonitor = Vue.observable({
  attributeDialogFlag: false,
});

Object.defineProperty(window, "attributeDialogFlag", {
  get() {
    return variableMonitor.attributeDialogFlag;
  },

  set(attributeDialogFlag) {
    variableMonitor.attributeDialogFlag = attributeDialogFlag;
  },
});

export default {
  name: "HTMLBuilder",

  components: {
    Table,
    SButton,
    AddAttribute,
    SInput,
  },

  data() {
    return {
      tableDialog: false,
      selectedElementId: "",
      // addBtn: null,
      // attributeDialogFlag: false,
    };
  },

  methods: {
    sourceCode() {
      console.log(
        this.beautify(document.getElementById("sharkEditor").innerHTML)
      );
    },
    format(command, value) {
      document.execCommand(command, false, value);
    },
    openTableDialog() {
      this.tableDialog = true;
    },
    closeTableDialog() {
      this.tableDialog = false;
    },
    addTable(val) {
      this.tableDialog = false;
      document.getElementById("sharkEditor").focus();
      let rows = "",
        columns = "",
        columnId = [],
        rowId = [];
      for (let i = 0; i < val.length; i++) {
        columns = "";
        rowId[i] = JSFunctions.uuid();

        for (let j = 0; j < val[i].columns.length; j++) {
          columnId[j] = JSFunctions.uuid();
          columns =
            columns +
            '<td style="border: 1px solid #e2e2e2;" id="' +
            columnId[j] +
            '"></td>';
        }
        console.log(columns);
        rows = rows + '<tr style="height:100px">' + columns + "</tr>";
      }
      let tableId = JSFunctions.uuid();

      document.execCommand(
        "insertHTML",
        false,
        "<table style='border-collapse: collapse;width: 100%;'>" +
          rows +
          "</table>"
      );

      for (let i = 0; i < columnId.length; i++) {
        let col = document.getElementById(columnId[i]);

        // col.style.position = 'relative';
        // col.style.zIndex = 1;

        let btn = document.createElement("img");
        btn.src = require("../../assets/Add.png");
        btn.id = "addBtn" + columnId[i];
        btn.style.width = "16px";
        btn.style.height = "16px";
        btn.style.float = 'left';
        btn.style.visibility = "hidden";
        btn.style.cursor = "pointer";
        col.appendChild(btn);

        col.addEventListener("mouseenter", function () {
          btn.style.visibility = "visible";
        });

        col.addEventListener("mouseleave", function () {
          btn.style.visibility = "hidden";
        });
      }

      // buttons for columns
      for (let i = 0; i < columnId.length; i++) {
        console.log(columnId[i]);
        console.log(
          document.getElementById(columnId[i]).parentElement.offsetWidth
        );
        let widthOfColumn =
          document.getElementById(columnId[i]).parentElement.offsetWidth /
          columnId.length;
        console.log(widthOfColumn);
        document.getElementById(columnId[i]).style.width = widthOfColumn + "px";
      }
    },
    addGrid(val) {
      val = 3;
      let gridItems = "";
      for (let i = 0; i < val; i++) {
        gridItems = gridItems + "<div style='border: 1px solid red'></div>";
      }
      document.execCommand(
        "insertHTML",
        true,
        "<div style='display:grid;height:100px;grid-template-columns: repeat(" +
          3 +
          ",1fr" +
          ");'>" +
          gridItems +
          "</div> </br>"
      );
    },
    beautify(html) {
      var tab = "\t";
      var result = "";
      var indent = "";

      html.split(/>\s*</).forEach(function (element) {
        if (element.match(/^\/\w/)) {
          indent = indent.substring(tab.length);
        }

        result += indent + "<" + element + ">\r\n";

        if (element.match(/^<?\w[^>]*[^\/]$/) && !element.startsWith("input")) {
          indent += tab;
        }
      });

      return result.substring(1, result.length - 3);
    },
    openAttributeDialog() {
      window.attributeDialogFlag = true;
    },
    closeAttributeDialog() {
      window.attributeDialogFlag = false;
    },
    addAttribute(id, value) {
      window.attributeDialogFlag = false;
      document.getElementById(id).setAttribute("shark", value);
    },
    addDiv() {
      if (window.getSelection().toString()) {
        let id = JSFunctions.uuid();
        let text = window.getSelection().toString();
        document.execCommand("insertHTML", false, '<sk id="' + id + '"></sk>');
        this.selectedElementId = id;
        document.getElementById(id).textContent = text;
        document.getElementById(id).addEventListener("mouseenter", function () {
          // start
          let btn = document.createElement("Button");
          btn.innerHTML = "+";
          btn.style.border = "1px solid red";
          btn.style.background = "none";
          btn.style.borderRadius = "999px";
          btn.style.cursor = "pointer";
          btn.contentEditable = "false";
          btn.setAttribute("id", "custom_btn_" + id);
          document.getElementById(id).appendChild(btn);
          btn.addEventListener("click", function () {
            window.attributeDialogFlag = true;
          });
          // end
        });
        document.getElementById(id).addEventListener("mouseleave", function () {
          document.getElementById("custom_btn_" + id).remove();
        });
      }
    },
  },

  created() {
    window.addEventListener("load", function () {
      document
        .getElementById("sharkEditor")
        .setAttribute("contenteditable", "true");
      console.log("abc");
    });

  },
  mounted() {
    window.addEventListener("load", function () {
      document
        .getElementById("sharkEditor")
        .setAttribute("contenteditable", "true");
      console.log("abc");
    });
  },
  updated() {
    window.addEventListener("load", function () {
      document
        .getElementById("sharkEditor")
        .setAttribute("contenteditable", "true");
      console.log("abc");
    });
    // console.log(window.attributeDialogFlag.subscribe)
    // window.attributeDialogFlag.subscribe(val=>{
    //   // window.attributeDialogFlag=
    //   console.log("Abc")
    // })
  },
  computed: {
    // attributeDialogFlag() {
    //   return window.attributeDialogFlag;
    // },
    attributeDialogFlag() {
      return window.attributeDialogFlag;
    },
  },
};
</script>
<style lang="scss" scoped>
.editor {
  border: solid 1px #ccc;
  padding: 20px;
  min-height: 200px;
}

.toolbar {
  border: solid 1px #ddd;
  background: #f4f4f4;
  padding: 5px;
  border-radius: 3px;
}

.toolbar > span {
  cursor: pointer;
}

.toolbar > span:hover {
  text-decoration: underline;
}
a {
  color: #000;
  text-decoration: none;
  padding: 8px;
}

tr:nth-child(even) {
  background-color: #f2f2f2;
}
</style>